<template>
  <div class="flex flex-col">
    <button v-if='component.type === "text"' @click='onEdit' class="w-full h-full bg-white shadow my-2 mx-1 rounded border-0">
        {{component.text ? component.text : "Tap here to enter text..."}}
    </button>

    <button v-else @click='onEdit' class='relative'>
      <condensed  :component='component'
                  :transform='transform'
                  :transforms-and-source='transformsAndSource'
                  :partutil='partutil'
                  :disable-icon='true'
                  @edit='onEdit'
                  :treeutil='treeutil' />
      <span class="font-bold absolute left-0 top-0 text-white">Tap to change.</span>
    </button>

    <instant-choose-pack v-if='false'
                         class="h-24"
                         :partutil='partutil'
                         :render-tools='renderTools'
                         :selected-layers='{}'
                         :holder-data='holderData'
                         :layers='transformsAndSource.from.layers'
                         @select='onSelect'
                         direction='horizontal' />

  </div>
</template>
<script>
import { cloneDeep, debounce } from 'lodash';
import InstantChoosePack from '@ui/organisms/InstantChoosePack.vue';
import Condensed from '@components/molecules/Condensed.vue';

export default {
  props: {
    component: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    transform: {
      type: Object,
      required: true
    },
    partutil: {
      type: Object,
      required: true
    },
    selectionsData: {
      type: Array,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    }
  },
  data() {
    const gamedata = this.partutil.gamedata.gamedata;
    const shadowComponent = cloneDeep(this.component);
    const treeutil = this.partutil.getTreeUtil();
    return {
      gamedata,
      shadowComponent,
      treeutil
    }
  },
  mounted() {
    this.restartGame = debounce(this._restartGame, 300);
    this.updateText = debounce(this._updateText, 400);
  },
  beforeDestroy() {
  },
  methods: {
    onEdit() {
      this.$emit('edit', {
        component: this.component,
        transform: this.transform
      });
    },
    onInputText(component, e) {
      component.text = e.target.value;
      this.$emit('update', component);
      this.updateText();
    },
    _updateText() {
      this.$emit('change', {
        nv: this.component,
        ov:this.shadowComponent
      });
      this.shadowComponent = cloneDeep(this.component);
    },
    onFocus() {
      this.$emit("keyboard-open");
    },
    onBlur() {
      this.$emit("keyboard-close");
    },
    onSelect({type,data}) {
      console.log('selected', type, data);
      const ov = cloneDeep(this.component);
      if (type === 'spritesheet') {
        this.$set(this.component, 'atlas', data.spritesheet.id);
        this.$set(this.component, 'texture', data.image.name);
        this.$set(this.component, 'sprite', data.image.name);
        this.$set(this.component, 'firstLoad', true);
        //this.component.firstLoad = true;
        //const holder = this.holderData[this.transform.id].holder
        //console.log('have holder', holder);
        //this.renderTools.addToUpdateBatch(holder);
      } else if (type === 'upload') {
        this.$set(this.component, 'atlas', '');
        this.$set(this.component, 'texture', data.image.id);
        this.$set(this.component, 'sprite', data.image.id);
        this.$set(this.component, 'firstLoad', true);
      } else {
        console.error('dont support', type, 'yet');
      }
      this.$emit('change', {
        nv: this.component,
        ov
      });
    },
    _restartGame() {
      this.$refs.player.restartGame();
    },
  },
  components:{
    InstantChoosePack,
    Condensed
  },
  watch: {
    component(nv) {
      this.shadowComponent = cloneDeep(nv);
    }
  },
  computed: {
  }
}
</script>
<style>
</style>
